import styled from 'styled-components';

import { hexToRGB } from '@/styles/helpers';

export const ScWithdrawalTime = styled.div`
  display: flex;
  gap: 8px;
  width: max-content;
  background-color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.3)};
  backdrop-filter: blur(2px);
  padding: 8px 12px 6px;
  border-radius: 0 0 8px 8px;
  align-items: center;
  & .clock-wrapper {
    width: 20px;
    height: 20px;
    i {
      font-size: 20px;
    }
  }

  & .text-time {
    color: ${({ theme }) => theme.whiteColor};
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
  }
`;
